import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const LAST_VISIT_KEY = 'lastSiteVisit';
export const ONE_DAY_MS = 24 * 60 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class LastVisitService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    // AppComponent injects this service purely for these listeners, so the
    // constructor runs on every route - a server render included, where there
    // is no document to listen on and no visit to record.
    if (!isPlatformBrowser(this.platformId)) return;

    // visibilitychange covers most mobile & modern browsers
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this.updateLastVisit();
      }
    });

    // beforeunload as a fallback for desktop
    window.addEventListener('beforeunload', () => {
      this.updateLastVisit();
    });
  }

  private updateLastVisit(): void {
    localStorage.setItem(LAST_VISIT_KEY, new Date().toISOString());
  }
}
